import { useState } from 'react'

import arrowIcon from 'assets/images/explore-learnings/arrow-right.svg'

import { PractitionerCard } from './PractitionerCard'
import { PractitionerModal } from './PractitionerModal'
import { ResourceCard } from './ResourceCard'
import { SkillCard } from './SkillCard'

interface SkillSearchSectionProps {
  skill: any
  resources: any
  practitioners: any
  goResources: () => void
  goPractitioners: () => void
  border?: boolean
}

export const SkillSearchSection = ({
  skill,
  resources,
  practitioners,
  goResources,
  goPractitioners,
  border = true,
}: SkillSearchSectionProps) => {
  const [selectedPractitioner, setSelectedPractitioner] = useState<any>(undefined)
  return (
    <div className={`flex font-TCCC ${border ? 'border-b border-solid border-[#D7D7D7]' : ''} pb-6 w-full`}>
      <div className="mr-8">
        <SkillCard name={skill.name} image={skill.iconUrl} type="BIG" description={skill.description} id={skill.id} />
      </div>
      <div className="flex flex-col w-[736px] pt-[3px]">
        <div className="flex flex-col">
          <div className="flex justify-between mb-4">
            <p className="font-bold text-14 text-[#505050]">RELATED RESOURCES</p>
            <button className="flex font-bold text-14" onClick={() => goResources()}>
              See more <img src={arrowIcon} alt="Arrow" className="ml-2 size-5" />
            </button>
          </div>
          <div
            className={`flex flex-wrap gap-x-4 justify-between ${practitioners.length === 0 ? 'gap-y-14' : 'gap-y-0'}`}
          >
            {resources.map((resource: { name: string; description: string; url: string }) => (
              <ResourceCard
                key={resource.name}
                title={resource.name}
                description={resource.description}
                link={resource.url}
                type="small"
                className="w-[357px]"
              />
            ))}
          </div>
        </div>
        {practitioners && practitioners.length > 0 && (
          <div className="flex flex-col mt-8">
            <div className="flex justify-between mb-4">
              <p className="font-bold text-14 text-[#505050]">COMMUNITY OF PRACTITIONERS</p>
              <button className="flex font-bold text-14" onClick={() => goPractitioners()}>
                See more <img src={arrowIcon} alt="Arrow" className="ml-2 size-5" />
              </button>
            </div>
            <div className="flex gap-x-4">
              {practitioners.map(
                (practitioner: {
                  id: string
                  photoUrl: string
                  name: string
                  surname: string
                  email: string
                  role: string
                  location: string
                  skills: any
                }) => (
                  <div
                    className="cursor-pointer"
                    onClick={() => setSelectedPractitioner(practitioner)}
                    key={practitioner.id}
                  >
                    <PractitionerCard
                      imageUrl={practitioner.photoUrl}
                      name={`${practitioner.name} ${practitioner.surname}`}
                      email={practitioner.email}
                      role={practitioner.role}
                      location={practitioner.location}
                      key={practitioner.email}
                      tags={practitioner.skills}
                    />
                  </div>
                ),
              )}
              {selectedPractitioner && (
                <PractitionerModal
                  selectedPractitioner={selectedPractitioner}
                  onClose={() => setSelectedPractitioner(undefined)}
                />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
